import React from 'react';
import { Heart, Sparkles, Stethoscope, ShieldCheck, BadgeCheck, PawPrint } from 'lucide-react';
import { WHY_CHOOSE_US } from '../data/mock';

const ICONS = { Heart, Sparkles, Stethoscope, ShieldCheck, BadgeCheck };

const WhyChooseUs = () => {
  return (
    <section className="py-20 lg:py-28 bg-white relative overflow-hidden">
      <div className="absolute -top-20 -left-20 w-80 h-80 bg-[#f3d6f5]/40 rounded-full blur-3xl" />
      <div className="absolute -bottom-20 -right-20 w-80 h-80 bg-[#fbe6f5]/60 rounded-full blur-3xl" />

      <div className="relative max-w-[1280px] mx-auto px-5 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 text-[#e870b6] font-semibold tracking-[0.2em] text-[13px] uppercase mb-3">
            <PawPrint size={16} /> Why Pet Parents Choose Us
          </span>
          <h2 className="font-serif text-[40px] lg:text-[54px] font-extrabold text-[#1a0b3d] leading-[1.1] max-w-3xl mx-auto">
            More than a pet care center &mdash; a sanctuary.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY_CHOOSE_US.map((item, idx) => {
            const Icon = ICONS[item.icon] || PawPrint;
            return (
              <div
                key={item.title}
                className="group bg-white rounded-2xl p-7 border border-slate-100 shadow-sm hover:shadow-xl hover:border-[#f3d6f5] transition-all duration-300 hover:-translate-y-1"
                style={{ animationDelay: `${idx * 60}ms` }}
              >
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#fdf3fc] to-[#f3d6f5] flex items-center justify-center mb-5 group-hover:from-[#5b3eb5] group-hover:to-[#7c4ec9] transition-all">
                  <Icon className="w-7 h-7 text-[#5b3eb5] group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-serif text-[22px] font-bold text-[#1a0b3d] mb-3 leading-snug">
                  {item.title}
                </h3>
                <p className="text-slate-600 text-[15px] leading-relaxed">{item.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
